// extracted by mini-css-extract-plugin
export default {"zoomModal":"J3-z","image":"K3-z","button":"L3-z","isOverlayShown":"M3-z"};